import { AI_SERVICE_URL } from '@/config/constants';

import { streamSlideshowSSE } from './sseClient';
import type { SlideshowEvent, StartSlideshowRequest } from './types';

const baseUrl = () => `${AI_SERVICE_URL}/ai/assistant/slideshow`;

export const startSlideshow = (
    body: StartSlideshowRequest,
    token: string,
    onEvent: (event: SlideshowEvent) => void,
    signal?: AbortSignal,
): Promise<void> =>
    streamSlideshowSSE({
        url: `${baseUrl()}/`,
        body,
        token,
        signal,
        onEvent,
    });
